export const SAVED_VIEWS = [
  { value: 'all_rows', label: 'All rows' },
  { value: 'file_health_blockers', label: 'File health blockers' },
  { value: 'missing_account', label: 'Missing SF account' },
  { value: 'cpq_cleanup', label: 'CPQ cleanup' },
  { value: 'gm_corrections', label: 'GM corrections' },
  { value: 'high_dollar', label: 'High dollar' },
  { value: 'reviewed_with_blockers', label: 'Reviewed with blockers' },
  { value: 'completed', label: 'Completed' },
];
export const COMPLETED_VIEW = 'completed';
export const ALL_ROWS_VIEW = 'all_rows';

const text = (value) => (value === null || value === undefined ? '' : String(value));

const driverCode = (row = {}) => text(
  row.autoDriver || row.auto_driver || row.varianceDriver?.code || row.reviewDriver,
).toUpperCase();

const missingAccount = (row = {}) => {
  const summary = row.accountMatchSummary || row.account_match_summary || {};
  if (summary.status === 'matched' || summary.status === 'single_account') return false;
  if (summary.status === 'unmatched' || summary.status === 'ambiguous') return true;
  return Number(summary.uniqueAccountCount ?? summary.unique_account_count ?? 0) !== 1;
};

const completedVariance = (row = {}) => {
  const review = row.review || {};
  return Boolean(row.reviewed || review.reviewed);
};

export const buildFileHealthByBac = ({ openFileHealth = [], serverFileHealthSummary = {} } = {}) => {
  if (Array.isArray(serverFileHealthSummary.byBac) && serverFileHealthSummary.byBac.length) {
    return serverFileHealthSummary.byBac.reduce((acc, row) => {
      if (!row.bac) return acc;
      acc[String(row.bac)] = {
        total: Number(row.open || 0),
        errors: Number(row.error || 0),
        warnings: Number(row.warning || 0),
        infos: Number(row.info || 0),
      };
      return acc;
    }, {});
  }
  return openFileHealth.reduce((acc, finding) => {
    if (!finding.bac) return acc;
    const key = String(finding.bac);
    acc[key] = acc[key] || { total: 0, errors: 0, warnings: 0, infos: 0 };
    acc[key].total += 1;
    if (finding.tier === 'error') acc[key].errors += 1;
    else if (finding.tier === 'warning') acc[key].warnings += 1;
    else acc[key].infos += 1;
    return acc;
  }, {});
};

export const applySavedView = (rows, savedView, fileHealthByBac = {}) => {
  if (savedView === 'file_health_blockers') {
    return rows.filter((row) => Number(fileHealthByBac[String(row.bac)]?.errors || 0) > 0);
  }
  if (savedView === 'missing_account') return rows.filter(missingAccount);
  if (savedView === 'cpq_cleanup') {
    return rows.filter((row) => {
      const driver = driverCode(row);
      return driver.includes('CPQ') || row.status === 'missing-cpq';
    });
  }
  if (savedView === 'gm_corrections') {
    return rows.filter((row) => {
      const driver = driverCode(row);
      return driver.includes('GM') || row.status === 'missing-gm';
    });
  }
  if (savedView === 'high_dollar') {
    return rows.filter((row) => Math.abs(Number(row.maxAbsDelta ?? row.max_abs_delta ?? 0)) >= 1000);
  }
  if (savedView === 'reviewed_with_blockers') {
    return rows.filter((row) => {
      return completedVariance(row) && Number(fileHealthByBac[String(row.bac)]?.errors || 0) > 0;
    });
  }
  if (savedView === COMPLETED_VIEW) return rows.filter(completedVariance);
  if (savedView === ALL_ROWS_VIEW) return rows;
  return rows;
};
